import React, { useMemo } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { buildWhatsAppHref, readSupportConfig } from '../utils/supportContact';
import './WhatsAppFloatingButton.css';

const WhatsAppFloatingButton = ({ message }) => {
  const { waDigits, waMessage } = useMemo(() => readSupportConfig(), []);
  const href = buildWhatsAppHref(waDigits, message ?? waMessage);

  if (!href) return null;

  return (
    <a
      className="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="WhatsApp support"
    >
      <FaWhatsapp className="whatsapp-fab__icon" aria-hidden />
      <span className="whatsapp-fab__pulse" aria-hidden />
    </a>
  );
};

export default WhatsAppFloatingButton;
